import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import { NbDialogRef, NbToastrService, NbDialogService } from '@nebular/theme';

import { Patient } from 'app/@core/interfaces/common/CalorieFriend/patients';
import { ConfirmMessageDialogComponent } from 'app/@components/confirm-message-dialog/confirm-message-dialog.component';
import {
  FitnessPlanData,
  MealPlanData,
} from 'app/@core/interfaces/common/CalorieFriend/plan';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-patient-calendar-modal',
  templateUrl: './calendar-modal.component.html',
  styleUrls: ['./calendar-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DatePipe],
})
export class PatientCalendarModalComponent {
  patient: Patient;
  isFitness: boolean;
  planId: number;
  programStartDate: Date = null;
  activeDayIsOpen: boolean = false;
  isWaiting: boolean = false;

  private _plansService: FitnessPlanData | MealPlanData = null;

  constructor(
    private ref: NbDialogRef<PatientCalendarModalComponent>,
    private fitnessPlansService: FitnessPlanData,
    private mealPlansService: MealPlanData,
    private toastrService: NbToastrService,
    private dialogService: NbDialogService,
    private datePipe: DatePipe,
    private cdRef: ChangeDetectorRef
  ) {}

  get plansService(): FitnessPlanData | MealPlanData {
    if (!this._plansService) {
      this._plansService = this.isFitness
        ? this.fitnessPlansService
        : this.mealPlansService;
    }

    return this._plansService;
  }

  onClose(): void {
    this.ref.close();
  }

  onSendToClient(): void {

    /*
    if (this.isFuture()) {
      this.dialogService.open(ConfirmMessageDialogComponent, {
        closeOnEsc: true,
        closeOnBackdropClick: true,
        context: {
          isAlert: true,
          Message: `Plan will also automatically be sent on ${this.datePipe.transform(
            this.programStartDate
          )}.`,
          Title: 'Info',
        },
      });
      return;
    }*/

    if (this.isWaiting || !this.planId) return;

    this.isWaiting = true;
    this.cdRef.detectChanges();

    this.plansService
      .submitPatientNotification(this.patient.id, this.planId, true)
      .subscribe(() => this.toastrService.success('', 'Plan sent successfully'))
      .add(() => {
        this.isWaiting = false;
        this.cdRef.detectChanges();
      });
  }

  isFuture(): boolean {
    const today = new Date();
    return this.programStartDate > today;
  }
}
